<tr *ngIf="node">
  <td [attr.colspan]="colspan">
    <div
      *ngIf="!isVerticalNode"
      class="ui-organizationchart-nodecontent ui-widget-content ui-corner-all {{node.styleClass}}"
      [ngClass]="{'ui-organizationchart-selectable-node': chart.selectionMode && node.selectable !== false,'ui-state-highlight':isSelected()}"
      (click)="onNodeClick($event,node)"
      [style.margin-left.px]="marginLeft"
    >
      <div *ngIf="!chart.getTemplateForNode(node)">{{node.label}}</div>
      <div *ngIf="chart.getTemplateForNode(node)">
        <ng-container
          *ngTemplateOutlet="chart.getTemplateForNode(node); context: {$implicit: node}"
        ></ng-container>
      </div>

      <a
        #middle
        *ngIf="!leaf&&!node.showInVertical&&node.verticalBranchLevel === 0"
        tabindex="0"
        [ngClass]="node.expanded ? 'ui-node-toggler-expanded' : 'ui-node-toggler'"
        (click)="toggleNode($event, node)"
        (keydown.enter)="toggleNode($event, node)"
      ></a>
      <a
        #left
        *ngIf="!leaf&&node.showInVertical"
        tabindex="0"
        [ngClass]="node.expanded ? 'ui-node-toggler-left-expanded' : 'ui-node-toggler-left'"
        (click)="toggleNode($event, node)"
        (keydown.enter)="toggleNode($event, node)"
      ></a>
      <a
        #right
        *ngIf="!leaf&&node.verticalBranchLevel>=1"
        tabindex="0"
        [ngClass]="node.expanded ? 'ui-node-toggler-right-expanded' : 'ui-node-toggler-right'"
        (click)="toggleNode($event, node)"
        (keydown.enter)="toggleNode($event, node)"
      ></a>
    </div>

    <div *ngIf="isVerticalNode" [style.margin-left.em]="2">
      <div class="line-V"></div>
      <div class="row">
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 row divtest">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 firstdiv"></div>
          <div
            *ngIf="!last"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 seconddiv"
          ></div>
        </div>
        <div
          class=" col-xs-11 col-sm-11 col-md-11 col-lg-11 vertical-node-td ui-organizationchart-nodecontent ui-widget-content ui-corner-all {{node.styleClass}}"
          [ngClass]="{'ui-organizationchart-selectable-node': chart.selectionMode && node.selectable !== false,'ui-state-highlight':isSelected()}"
          (click)="onNodeClick($event,node)"
          style="margin-left: 1em"
        >
          <div *ngIf="!chart.getTemplateForNode(node)">{{node.label}}</div>
          <div *ngIf="chart.getTemplateForNode(node)">
            <ng-container
              *ngTemplateOutlet="chart.getTemplateForNode(node); context: {$implicit: node}"
            ></ng-container>
          </div>

          <a
            #middle
            *ngIf="!leaf&&!node.showInVertical&&node.verticalBranchLevel === 0"
            tabindex="0"
            [ngClass]="node.expanded ? 'ui-node-toggler-expanded' : 'ui-node-toggler'"
            (click)="toggleNode($event, node)"
            (keydown.enter)="toggleNode($event, node)"
          ></a>
          <a
            #left
            *ngIf="!leaf&&node.showInVertical"
            tabindex="0"
            [ngClass]="node.expanded ? 'ui-node-toggler-left-expanded' : 'ui-node-toggler-left'"
            (click)="toggleNode($event, node)"
            (keydown.enter)="toggleNode($event, node)"
          ></a>
          <a
            #right
            *ngIf="!leaf&&node.verticalBranchLevel>=1"
            tabindex="0"
            [ngClass]="node.expanded ? 'ui-node-toggler-right-expanded' : 'ui-node-toggler-right'"
            (click)="toggleNode($event, node)"
            (keydown.enter)="toggleNode($event, node)"
          ></a>
        </div>
      </div>
    </div>
  </td>
</tr>
<tr
  *ngIf="!node.showInVertical&&node.verticalBranchLevel === 0 && node.expanded"
  [style.visibility]="!leaf ? 'inherit' : 'hidden'"
  class="ui-organizationchart-lines"
  [@childState]="'in'"
>
  <td [attr.colspan]="colspan">
    <div class="ui-organizationchart-line-down"></div>
  </td>
</tr>

<tr
  *ngIf="!node.showInVertical&&node.verticalBranchLevel === 0 && node.expanded"
  [style.visibility]="!leaf ? 'inherit' : 'hidden'"
  class="ui-organizationchart-lines"
  [@childState]="'in'"
>
  <ng-container *ngIf="node.children && node.children.length === 1">
    <td [attr.colspan]="colspan">
      <div class="ui-organizationchart-line-down"></div>
    </td>
  </ng-container>
  <ng-container *ngIf="node.children && node.children.length > 1">
    <ng-template
      ngFor
      let-child
      [ngForOf]="node.children"
      let-first="first"
      let-last="last"
    >
      <td
        class="ui-organizationchart-line-left"
        [ngClass]="{'ui-organizationchart-line-top':!first}"
      >
        &nbsp;
      </td>
      <td
        class="ui-organizationchart-line-right"
        [ngClass]="{'ui-organizationchart-line-top':!last}"
      >
        &nbsp;
      </td>
    </ng-template>
  </ng-container>
</tr>

<tr
  *ngIf="!node.showInVertical&&node.verticalBranchLevel === 0 && node.expanded"
  [style.visibility]="!leaf ? 'inherit' : 'hidden'"
  class="ui-organizationchart-nodes"
  [@childState]="'in'"
>
  <td *ngFor="let child of node.children" colspan="2">
    <table
      class="ui-organizationchart-table"
      pTreeChartNode
      [node]="child"
      aria-hidden="true"
    ></table>
  </td>
</tr>
<div [ngClass]="!last?'leftLineBranch2':''">
  <tr
    *ngIf="!node.showInVertical && node.verticalBranchLevel >=1 && node.expanded"
    [style.visibility]="!leaf ? 'inherit' : 'hidden'"
    class="ui-organizationchart-nodes"
    [@childState]="'in'"
  >
    <div
      *ngFor="let child of node.children;let last = last"
      class="row"
      [style.margin-left.em]="11"
    >
      <div
        class="ui-organizationchart-table"
        pTreeChartNode
        [node]="child"
        [isVerticalNode]="true"
        [last]="last"
        [marginLeft]="0"
      ></div>
    </div>
  </tr>
</div>
<tr
  *ngIf="node.showInVertical&&node.expanded"
  [style.visibility]="!leaf ? 'inherit' : 'hidden'"
  class="ui-organizationchart-nodes"
  [@childState]="'in'"
>
  <div class="">
    <div
      *ngFor="let child of node.children;let last = last"
      class="row"
      [style.margin-left.em]="node.marginLeft >0 ? node.marginLeft : 1"
    >
      <div
        class="ui-organizationchart-table"
        pTreeChartNode
        [node]="child"
        [isVerticalNode]="true"
        [last]="last"
      ></div>
    </div>
  </div>
</tr>
